'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _hoistNonReactStatics = require('hoist-non-react-statics');

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = _hoistNonReactStatics2.default; // Adapter for:
// https://github.com/mridgway/hoist-non-react-statics